module.exports = __webpack_public_path__ + "img/cartoon.328bece2.png";